import Affiliate from "../../apis/affiliate";
// import RepositoryFactory from "@/apis";
// const Affiliate = RepositoryFactory.affiliate;

export default {
  //PRODUCTS
  createProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.createProduct(payload);
        // commit("CREATE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getProduct(payload);
        commit("GET_PRODUCT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getAllProduct(payload);
        commit("GET_ALL_PRODUCT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateProduct(payload);
        // commit("UPDATE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.deleteProduct(payload);
        // commit("DELETE_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////ORDERS////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  createOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.createOrder(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getOrder(payload);
        commit("GET_ORDER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateOrder(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getBrandOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getBrandOrder(payload);
        commit("GET_ORDER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  orderStatus({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.orderStatus(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  orderCount({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.orderCount(payload);
        commit("ORDER_COUNT", data.data.count[0]);
        resolve(data);
      } catch (error) {
        reject(error);
        console.log(error);
      }
    });
  },

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////CART///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  addItem({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.addItem(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCart({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getCart(payload);
        commit("GET_CART", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  removeItem({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.removeItem(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateCart({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateCart(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateAddress({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateAddress(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////BRAND/////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  createBrand({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.createBrand(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getBrand({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getBrand(payload);
        commit("GET_BRAND", data.data.result);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateBrand({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateBrand(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteBrand({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.deleteBrand(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////VENDOR///////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////

  addVendor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.addVendor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllVendor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getAllVendor(payload);
        commit("GET_ALL_VENDOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getVendorByAdmin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getVendorByAdmin(payload);
        commit("GET_ALL_VENDOR", data.data[0]);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getVendorProduct({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getVendorProduct(payload);
        commit("GET_VENDOR_PRODS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getVendorById({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getVendorById(payload);
        commit("GET_VENDOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateVendor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateVendor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteVendor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.deleteVendor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  
  ////////////////////////////////////////////////////////////////////////////
  ////////////////////////////AFFILIATE URL///////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  createUrl({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.createUrl(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getUrl({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.getUrl(payload);
        commit("GET_AFFILIATE_URL", data.data.result);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateUrl({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.updateUrl(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteUrl({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Affiliate.deleteUrl(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
